import React from "react";
import { Alert } from "@mui/material";
import { BulkUserUploadCard } from "./BulkUserUploadCard";
import { SettingsSection } from "./SettingsSection";

interface BulkUploadTabProps {
  effectiveClientId: string | null;
  isCentralAdmin: boolean;
}

export const BulkUploadTab: React.FC<BulkUploadTabProps> = ({
  effectiveClientId,
  isCentralAdmin,
}) => {
  if (!isCentralAdmin) return null;

  return (
    <SettingsSection
      title="Bulk Upload"
      description="Upload users for the selected client and preview validation before creating."
    >
      {!effectiveClientId ? (
        <Alert severity="info">
          Select a client before using bulk upload.
        </Alert>
      ) : (
        <BulkUserUploadCard
          effectiveClientId={effectiveClientId}
          isCentralAdmin={isCentralAdmin}
        />
      )}
    </SettingsSection>
  );
};
